
import React from "react";
import { Organization } from "@/types/organization";
import { Textarea } from "@/components/ui/textarea";

interface OrganizationInfoSectionProps {
  organization: Organization;
  aboutOrgText: string;
  setAboutOrgText: (value: string) => void;
  staffingText: string;
  setStaffingText: (value: string) => void;
}

export const OrganizationInfoSection: React.FC<OrganizationInfoSectionProps> = ({
  organization,
  aboutOrgText,
  setAboutOrgText,
  staffingText,
  setStaffingText
}) => {
  return (
    <div className="mt-8 space-y-4 bg-gray-50 p-4 rounded-md border text-left">
      <h3 className="text-lg font-medium">Organization information: {organization.name}</h3>
      
      <div className="space-y-2">
        <label className="block text-sm font-medium">About the organization</label>
        <Textarea 
          className="w-full bg-white p-3 rounded-md border min-h-[200px] text-sm" 
          placeholder="Enter information about your organization..." 
          value={aboutOrgText} 
          onChange={e => setAboutOrgText(e.target.value)} 
        />
      </div>
      
      <div className="space-y-2">
        <label className="block text-sm font-medium">Staffing and leadership</label>
        <Textarea 
          className="w-full bg-white p-3 rounded-md border min-h-[200px] text-sm" 
          placeholder="Enter information about your staffing and leadership..." 
          value={staffingText} 
          onChange={e => setStaffingText(e.target.value)} 
        />
      </div>
    </div>
  );
};
